var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"30","height":"34","viewBox":"0 0 30 34","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15 0L29.7224 8.5V25.5L15 34L0.277568 25.5V8.5L15 0Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }